import axiosInstance from './axiosInstance';

const featuresApi = {
    getUserFeatures: (userId, email) =>
        axiosInstance.post('/user/features', { userId, email }),
};

export default featuresApi;
